<script lang="ts">
	interface Props {
		// Label for the range slider
		label?: string
		// Minimum value for the range
		min?: number
		// Maximum value for the range
		max?: number
		// Step value for the range
		step?: number
		// Current value of the range slider
		value?: number
		// Disabled state for the slider
		disabled?: boolean
		oninput?: ((value: number) => void) | null
	}

	let {
		label = '',
		min = 0,
		max = 10,
		step = 1,
		value = $bindable(min),
		disabled = false,
		oninput = null
	}: Props = $props()

	// Emit the updated value on change
	function handleInput(event: Event) {
		const target = event.target as HTMLInputElement
		value = target.valueAsNumber
		oninput?.(value)
	}
</script>

<div class="range-container">
	{#if label}
		<label class="range-label">{label}</label>
	{/if}
	<div class="range-wrapper">
		<input
			type="range"
			{min}
			{max}
			{step}
			bind:value
			oninput={handleInput}
			{disabled}
			class="range-slider"
		/>
		<span class="range-value">{value}</span>
	</div>
</div>

<style>
	.range-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		font-family: Arial, sans-serif;
	}

	.range-label {
		font-size: 14px;
		font-weight: 500;
		margin-bottom: 8px;
		color: #606266;
	}

	.range-wrapper {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.range-slider {
		appearance: none;
		width: 100%;
		height: 8px;
		background: #e0e0e0;
		border-radius: 4px;
		outline: none;
		transition: background 0.2s ease;
	}

	.range-slider::-webkit-slider-runnable-track {
		background: linear-gradient(
			to right,
			#14d586 0%,
			#14d586 calc(var(--value) * 1%),
			#e0e0e0 calc(var(--value) * 1%),
			#e0e0e0 100%
		);
	}

	.range-slider::-webkit-slider-thumb {
		appearance: none;
		width: 16px;
		height: 16px;
		background: #f5f5f5;
		border: 2px solid #14d586;
		border-radius: 50%;
		cursor: pointer;
		transition:
			background 0.2s ease,
			border-color 0.2s ease;
	}

	.range-slider:focus::-webkit-slider-thumb {
		border-color: #0fb672;
		box-shadow: 0 0 5px rgba(20, 213, 134, 0.4);
	}

	.range-value {
		font-size: 14px;
		font-weight: 500;
		color: #606266;
		min-width: 24px;
		text-align: center;
	}
</style>
